import { render, staticRenderFns } from "./ReviewAndReport.vue?vue&type=template&id=224f269c&scoped=true&"
import script from "./ReviewAndReport.vue?vue&type=script&lang=ts&"
export * from "./ReviewAndReport.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewAndReport.vue?vue&type=style&index=0&id=224f269c&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224f269c",
  null
  
)

export default component.exports